<template>
    <div class="contentD">
        <div class="pageTitle">工作台设置</div>
        <div class="minTitle">快捷入口设置</div>
        <div>已勾选的菜单将显示到工作台 “快捷入口”，最多添加 {{ menuSeleTotle }} 个。</div>
        <div class="minTitle magTops">已选择</div>
        <div class="m_b2">
            <el-tooltip effect="dark" :content="item.name" placement="top" v-for="(item, index) in selMenuList"
                        :key="index">
                <div class="menu" @click="delMenu(item, index)">
                    <div :class="['icon', item.icon]"></div>
                    <div class="omit">{{ item.name }}</div>
                    <div class="delBtn flex_c_c">
                        <div class="el-icon-delete delIcon"></div>
                    </div>
                </div>
            </el-tooltip>
            <div class="noDataBox" v-if="!selMenuList.length">
                <img src="@/assets/img/noData.png" class="noData">
                <div>暂未选择快捷功能</div>
            </div>
        </div>
        <div class="flex_b_c">
            <div class="minTitle">全部</div>
            <div class="flex_l_c">
                <el-input class="m_r1" v-model.trim="menuName" size="small" @input="setParentList()" maxlength="50" suffix-icon="el-icon-search" placeholder="请输入关键字搜索"
                          style="width: 200px"></el-input>
            </div>
        </div>
        <div :class="['menuBox', !menuList.length ? 'flex_c_c':'']" v-loading="menuLoading">
            <el-tooltip effect="dark" :content="item.name" placement="top" v-for="(item, index) in menuList"
                        :key="index">
                <div class="menu" @click="selMenu(item)">
                    <div :class="['icon', item.icon]"></div>
                    <div class="omit">{{ item.name }}</div>
                </div>
            </el-tooltip>
            <div class="noDataBox" v-if="!menuList.length">
                <img src="@/assets/img/noData.png" class="noData">
                <div>暂无相关数据</div>
            </div>
        </div>

        <div class="minTitle magTops">待办事项业务设置</div>
        <div>仅开启状态的业务待办事项会同步到工作台 “待办事项”中。</div>
        <el-table
            v-loading="toDoLoading"
            :data="toDoList"
            size="small" height="250px"
            class="table magTops" border
            ref="multipleTable"
            :row-key="'id'"
        >
            <el-table-column prop="name" label="业务名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" width="150px" label="状态" sortable show-overflow-tooltip>
                <template slot-scope="{row}">
                    <el-switch
                        v-model="row.status"
                        active-value="0"
                        @change="setType(row)"
                        inactive-value="1">
                    </el-switch>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="toDoTotal" :page.sync="toDoSearch.current" :limit.sync="toDoSearch.size"
                    @pagination="getToDoList"/>

        <div class="minTitle magTops">业务版块设置</div>
        <div>仅开启状态的业务及数据会显示在工作台 “业务版块”中。</div>
        <el-table
            v-loading="serviceLoading"
            :data="serviceList"
            size="small" height="250px"
            class="table magTops" border
            ref="multipleTable"
            :row-key="'id'"
        >
            <el-table-column prop="name" label="业务名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="status" width="150px" label="状态" sortable show-overflow-tooltip>
                <template slot-scope="{row}">
                    <el-switch
                        v-model="row.status"
                        active-value="0"
                        @change="setServiceType(row)"
                        inactive-value="1">
                    </el-switch>
                </template>
            </el-table-column>
        </el-table>
        <pagination :total="serviceTotal" :page.sync="serviceSearch.current" :limit.sync="serviceSearch.size"
                    @pagination="getServiceList"/>
    </div>
</template>

<script>

export default {
    name: "setWorkbenches",
    data(){
        return{
            menuName: '',
            menuLoading:false,
            menuList: [], //菜单展示数据
            selMenuList: [], //已选择
            menuSeleTotle:0,

            toDoSearch:{
                current:1,
                size:20,
            },
            toDoTotal:0,
            toDoLoading:false,
            toDoList:[],//待办事项

            serviceSearch:{
                current:1,
                size:20,
            },
            serviceTotal:0,
            serviceLoading:false,
            serviceList:[],//待办事项
        }
    },

    mounted() {
        this.getSelMenuList()
        this.getToDoList()
        this.getServiceList()
    },

    methods:{
        getSelMenuList(){
            this.$axios(this.api.user.getSysMenuShortcutKeysByCreateBy, {}, 'get').then(data => {
                if (data && data.status) {
                    this.selMenuList = data.data
                    this.setParentList()
                }
            })
            this.$axios(this.api.user.configKey + 'sys.menu.fast', {}, 'get').then(data => {
                if (data && data.status) {
                    this.menuSeleTotle = data.data
                }
            })
        },

        //获取所有常用菜单的
        setParentList() {
            this.menuLoading = true
            let menuIds = this.selMenuList.map(item=>{
                return item.id
            })
            this.$axios(this.api.user.findByMenuResult, {
                menuIds:menuIds,
                menuName:this.menuName,
            }, 'post').then(data => {
                if (data && data.status) {
                    this.menuLoading = false
                    this.menuList = data.data
                }
            })
        },

        selMenu(item) {
            this.$axios(this.api.user.sysmenushortcutkeysSave, {
                menuId:item.id,
            }, 'post').then(data => {
                if (data && data.status) {
                    this.$message.success('添加成功')
                    this.getSelMenuList()
                }else {
                    this.$message.error(data.msg)
                }
            })
        },


        delMenu(item, index) {
            this.$confirm(`确定删除所选项吗?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios(this.api.user.sysmenushortcutkeysRemoveById + item.id, {}, 'delete').then(data => {
                    if (data && data.status) {
                        this.$message.success('删除成功')
                        this.getSelMenuList()
                    }else {
                        this.$message.success(data.msg)
                    }
                })
            })
        },

        //获取代办事项
        getToDoList(){
            this.toDoLoading = true
            this.$axios(this.api.user.sysMenuServiceSetupList, this.toDoSearch, 'get').then(data => {
                if (data && data.status) {
                    this.toDoList = data.data.records
                    this.toDoLoading = false
                    this.toDoTotal = parseInt(data.data.total)
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //切换待办事项状态
        setType(row) {
            row.status = row.status == '1' ? '0' : '1'
            this.$axios(this.api.user.sysMenuServiceSetupSave, {
                menuId: row.id,
                status: row.status == '1' ? '0' : '1',
            }, 'post').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.getToDoList()
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //获取业务
        getServiceList(){
            this.serviceLoading = true
            this.$axios(this.api.user.sysMenuBusinessSegmentList, this.serviceSearch, 'get').then(data => {
                if (data && data.status) {
                    this.serviceList = data.data.records
                    this.serviceLoading = false
                    this.serviceTotal = parseInt(data.data.total)
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

        //切换待办事项状态
        setServiceType(row) {
            row.status = row.status == '1' ? '0' : '1'
            this.$axios(this.api.user.sysMenuBusinessSegmentSave, {
                businessSegmentId: row.id,
                status: row.status == '1' ? '0' : '1',
            }, 'post').then(data => {
                if (data && data.status) {
                    this.$message.success('状态修改成功')
                    this.getServiceList()
                } else {
                    this.$message.error(data.msg)
                }
            })
        },

    },
}
</script>

<style lang="scss" scoped>
.contentD{
    padding: 15px;
    overflow-y: auto;
}

.pageTitle{
    font-weight: bold;
    font-size: 18px;
    margin-bottom: 20px;
}

.minTitle{
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 5px;
}

.menuBox {
    margin-top: 15px;
    height: 280px;
    overflow-y: auto;
}

.menu {
    padding: 10px 10px 0px;
    height: 70px;
    vertical-align: bottom;
    margin-top: 15px;
    text-align: center;
    border-radius: 0.29rem;
    border: 1px solid #EEEEEE;
    cursor: pointer;
    position: relative;
    display: inline-block;
    width: 10%;
    margin-right: 1%;
}

.menu:hover {
    border: 1px solid #AE3F3F;

    .delBtn {
        background: rgba(253, 243, 243, 0.5);
    }

    .delIcon {
        display: block;
    }
}

.delBtn {
    border-radius: 0.29rem;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    color: #AE3F3F;
    font-size: 22px;
}

.delIcon {
    display: none;
}

.icon {
    font-size: 18px;
    margin-bottom: 10px;
}

.noDataBox {
    text-align: center;
    font-size: 12px;
    color: #333333;
}

.noData {
    width: 7rem;
}

.el-descriptions__title {
    color: #000;
}

.magTops{
    margin-top: 15px;
}
</style>